import React, { ReactElement } from 'react'
import { components, GroupTypeBase, IndicatorProps } from 'react-select'
import styled from 'styled-components'
import { OptionType } from '../../../../common/types/utilities'

export const Container = styled.div`
    height: 100%;
    width: 100%;
    font-size: 14px;
    background-color: ${({ theme }) => theme['gray-0']};
    padding: 0%;
`

export const Div50 = styled.div`
    width: 50%;
    height: auto;
`

/* react-select styles stuff -- start -- */
const CarentIcon = styled.i`
    color: ${({ theme }) => theme['blue-500']};
`

export const DropdownIndicator = (props: IndicatorProps<any, any, any>): ReactElement => {
    return (
        components && components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen ? (
                    <CarentIcon className={'fas fa-caret-up'} />
                ) : (
                    <CarentIcon className={'fas fa-caret-down'} />
                )}
            </components.DropdownIndicator>
        )
    )
}

export const ResizableDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
`

export const Placeholder = (props: IndicatorProps<OptionType, boolean, GroupTypeBase<OptionType>>): JSX.Element => {
    return <components.Placeholder {...props} />
}
